import Vue from 'vue';

import i18n from '@/plugins/i18n';
import inputValidators from '@/plugins/Pwr/InputValidators';

import PwrCommonComponents from '@pwr/common-components';
import '@pwr/common-components/dist/common-components.css';

Vue.use(PwrCommonComponents, {
  inputValidators,
  i18n
});
